import { makeVar } from '@apollo/client'

export const showAppBannerVar = makeVar(false)
export const isSearchFocusedVar = makeVar(false)
